export enum ExposureCategory {
  CompanyFinancials = 1,
  EmployeeCount = 2,
  Payroll = 3,
  PlanFiduciaryAssets = 4,
  BusinessAuto = 5,
  PropertyLocations = 6,
  DetailedRevenueBreakout = 7,
  TravelLocations = 8,
  MarketCap = 9,
  GeneralLiability = 10
}

export interface ExposureOption {
  lookupKey: string
  value: string
  text: string
  indexPos: number
}

export interface ExposureAttribute {
  exposureAttributeValueId: number
  exposureAttributeId: number
  exposureAttributeKey: string
  exposureMetricId: number
  name: string
  required: boolean
  lookupKey?: string
  value?: string
  indexPos: number
  options?: ExposureOption[]
}

export interface ExposureAttributeWithLookupKey {
  lookupKey: string
}

export interface ExposureAttributeValueEntry {
  exposureAttributeID: number
  value: string
}

export interface ExposureAttributeValueChangeEntry extends ExposureAttributeValueEntry {
  exposureAttributeValueID: number
}

export interface ExposureValue {
  name: string
  exposureMetricID: number
  unitOfMeasure: string
  accountID?: number
  value?: number
  effectiveDate?: string
  uploadTimeStamp: string
  uploadedBy: string
  systemCreated?: boolean
  categoryID: number
  exposureID: number
  exposureAttributes: ExposureAttribute[]
}

export interface ExposureMetric {
  name: string
  exposureMetricID: number
  unitOfMeasure: string
  unitScale: string
  exposureCategoryID: number
  privateOnly: boolean
  exposureAttributes: ExposureAttribute[]
}

export interface ExposureValueEntry {
  value: number
  exposureMetricID: number
  effectiveDate: string
  exposureAttributeEntries: ExposureAttributeValueEntry[]
}

export interface ExposureValueChangeEntry extends ExposureValueEntry {
  exposureID: number
  exposureAttributeEntries: ExposureAttributeValueChangeEntry[]
}

export interface ExposureProperty {
  id: string
  accountID: string
  accountName?: string
  effectiveDate?: Date
  updatedAt?: Date
  updatedBy?: string
  locationName?: string
  address1?: string
  city?: string
  state?: string
  stateId?: number
  postalCode?: string
  county?: string
  latitude?: number
  longitude?: number
  buildingValue?: number
  otherPropertyValue?: number
  contentsValue?: number
  businessInterruptionValue?: number
  huDeductibleAmount?: number
  huDeductiblePercent?: number
  eqDeductibleAmount?: number
  eqDeductiblePercent?: number
  stDeductibleAmount?: number
  stDeductiblePercent?: number
  ifDeductibleAmount?: number
  ifDeductiblePercent?: number
  wfDeductibleAmount?: number
  wfDeductiblePercent?: number
  wsDeductibleAmount?: number
  wsDeductiblePercent?: number
  yearBuilt?: number
  stories?: number
  squareFootage?: number
  roofYearBuilt?: number
  renewables?: string
  renewablesId?: number
  construction?: string
  constructionId?: number
  occupancy?: string
  occupancyId?: number
  roofGeometry?: string
  roofGeometryId?: number
  roofCovering?: string
  roofCoveringId?: number
  roofAnchorage?: string
  roofAnchorageId?: number
  windowProtection?: string
  windowProtectionId?: number
  wallType?: string
  wallTypeId?: number
  wallSiding?: string
  wallSidingId?: number
  buildingShape?: string
  buildingShapeId?: number
  foundationType?: string
  foundationTypeId?: number
  userDefined5?: string
  userDefined4?: string
  userDefined3?: string
}

export interface ExposurePropertyData {
  id: number
  name: string
}

export interface ExposurePropertyRefData {
  category: string
  values: ExposurePropertyData[]
}

